var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.advertList.length > 0)?_c('div',{staticClass:"wrapper"},[_c('el-carousel',{attrs:{"height":"156px"}},_vm._l((_vm.advertList),function(v,i){return _c('el-carousel-item',{key:i},[_c('el-image',{attrs:{"src":v.image},on:{"click":function($event){return _vm.openUrl(v)}}})],1)}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }